import { StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
	page: {
		backgroundColor: '#fff',
		padding: 24,
	},
	subtitle: {
		fontSize: 14,
	},
	title: {
		fontSize: 20,
		fontWeight: 'bold',
	},
	courseName: {
		marginTop: 8,
		fontSize: 14,
	},
	headers: {
		marginTop: 8,
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center',
		borderBottom: '1px solid #ccc',
	},
	headerItem: {
		fontSize: 12,
		fontWeight: 500,
		width: '17.5%',
		display: 'flex',
		alignItems: 'center',
		textAlign: 'center',
	},
	divider: {
		width: '100%',
		height: 1,
	},
	row: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center',
		borderBottom: '1px solid #e6e6e6',
		padding: '8px 0px',
	},
	cell: {
		fontSize: 11,
		fontWeight: 400,
		width: '17.5%',
		display: 'flex',
		alignItems: 'center',
		textAlign: 'center',
	},
});

export default styles;
